import { gql } from "lib/apolloClient";

export const participantsStudentFragments = {
  basicDetails: gql`
    fragment participantStudentBasicDetailsItem on Student {
      id
      firstName
      middleName
      lastName
      preferredName
      profileImage
      type
      yearGroup {
        id
        grade {
          id
          name
        }
      }
    }
  `,
};

export const participantsStaffFragments = {
  basicDetails: gql`
    fragment participantStaffBasicDetailsItem on Staff {
      id
      firstName
      middleName
      lastName
      preferredName
      profileImage
      type
    }
  `,
};

export const participantsFamilyMemberFragments = {
  basicDetails: gql`
    fragment participantFamilyMemberBasicDetailsItem on FamilyMember {
      id
      firstName
      middleName
      lastName
      profileImage
      type
      children {
        id
        firstName
        middleName
        lastName
        preferredName
        pronouns
        suffix
        prefix
      }
    }
  `,
};
